export default __webpack_public_path__ + "static/sql-light-d3dc83b5d6c56a775281e8f50160820e.png";